import { render, staticRenderFns } from "./Txgl.vue?vue&type=template&id=50f84250&scoped=true&"
import script from "./Txgl.vue?vue&type=script&lang=js&"
export * from "./Txgl.vue?vue&type=script&lang=js&"
import style0 from "./Txgl.vue?vue&type=style&index=0&id=50f84250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f84250",
  null
  
)

export default component.exports